import {
  ADMIN_SUBMIT_USER_KYC,
  ADMIN_SUBMIT_USER_KYC_SUCCESS,
  ADMIN_SUBMIT_USER_KYC_FAILURE,
} from "../actionTypes";

export const adminSubmitUserKyc = (payload) => ({
  type: ADMIN_SUBMIT_USER_KYC,
  payload,
});

export const adminSubmitUserKycSuccess = (payload) => ({
  type: ADMIN_SUBMIT_USER_KYC_SUCCESS,
  payload,
});

export const adminSubmitUserKycFailure = () => ({
  type: ADMIN_SUBMIT_USER_KYC_FAILURE,
});